import { Component, OnInit } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ListaUfs } from "src/app/constants/lista.ufs";
import { MaskHelper } from "src/app/helpers/mask.helper";
import { CadastroUsuarioPlanoRequest } from "src/app/modules/auth/models/CadastroUsuarioPlanoRequest.model";
import { ItemLookupPlano } from "src/app/modules/auth/models/item-lookup-plano.model";
import { StatusService } from "src/app/services/status.service";
import { DetalhesAssinaturaResponse } from "../../modules/shared/arguments/assinatura/DetalhesAssinaturaResponse";
import { AssinaturaService } from "../../modules/shared/services/assinatura.service";
import { AuthService } from "../../modules/shared/services/auth.service";
import { FormControlValidators } from "../../modules/shared/validators/FormControlValidators";
import { ConsultaCepService } from "src/app/services/consulta.cep.service";
import { EnderecoModel } from "src/app/models/EnderecoModel";
import { ErrorHandlerService } from "src/app/services/errorHandler.service";

@Component({
  selector: "app-indicador-trial-trava-tela",
  templateUrl: "./indicador-trial-trava-tela.component.html",
  styleUrls: ["./indicador-trial-trava-tela.component.scss"],
})
export class IndicadorTrialTravaTelaComponent implements OnInit {
  public masks = MaskHelper;
  public problemaPagamento = false;
  public showModal = false;
  public plano!: DetalhesAssinaturaResponse;
  public diasRestantesAvaliacao = 0;
  public percentualIndicador = 0;
  public strDiasRestantes = "";
  public formStep = 1;

  public dadosPessoais = this.formBuilder.group({
    telefone: ["", [Validators.required]],
    cep: ["", [Validators.required, FormControlValidators.cep]],
    logradouro: ["", [Validators.required]],
    numeroLogradouro: ["", [Validators.required]],
    complemento: [""],
    bairro: ["", [Validators.required]],
    cidade: ["", [Validators.required]],
    uf: ["", [Validators.required]],
    siglaPais: ["BR", [Validators.required]],
  });
  public pagamento = this.formBuilder.group({
    cpf: ["", [FormControlValidators.cpf]],
    dataNascimento: ["", [Validators.required]],
    idPlano: ["", [Validators.required]],
    numeroCartao: ["", [Validators.required]],
    meioPagamento: ["", [Validators.required]],
    nomeTitularCartao: ["", [Validators.required]],
    vencimentoCartao: [
      "",
      [Validators.required, FormControlValidators.validadeCartao],
    ],
    codigoSegurancaCartao: ["", [Validators.required]],
    deAcordoTermoCompra: [false, [Validators.requiredTrue]],
  });
  public planos: ItemLookupPlano[] = [];

  public listaUfs = ListaUfs;

  public bandeirasCartao = [
    { id: 1, descricao: "VISA" },
    { id: 2, descricao: "AMEX" },
    { id: 3, descricao: "MASTERCARD" },
    { id: 4, descricao: "ELO" },
    { id: 5, descricao: "HIPERCARD" },
    { id: 6, descricao: "DINERS" },
  ];

  constructor(
    private auth: AuthService,
    private assinaturaService: AssinaturaService,
    private statusService: StatusService,
    private matSnackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private consultaCepService: ConsultaCepService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.assinaturaService.atualizaPlanoAtual();
    this.problemaPagamento = this.auth.getAccessToken().problemaPagamento;

    this.assinaturaService.getplanoplanoAtual().subscribe((plano) => {
      this.plano = plano;

      this.diasRestantesAvaliacao = Math.floor(
        this.plano?.diasRestantesAvaliacao
      );

      if (
        this.diasRestantesAvaliacao < 0 ||
        isNaN(this.diasRestantesAvaliacao)
      ) {
        this.diasRestantesAvaliacao = 0;
      }

      this.strDiasRestantes =
        this.diasRestantesAvaliacao === 1 ? "dia" : "dias";

      if (this.plano?.trialGratuito && this.diasRestantesAvaliacao <= 0) {
        this.showModal = true;
      }

      if (this.problemaPagamento && !this.plano?.trialGratuito) {
        this.showModal = true;
      }
    });

    this.planos = this.assinaturaService.listarPlanos(false);
    this.checkProblemaPagamento();
  }

  indicadorClicked() {
    this.showModal = true;
  }
  checkProblemaPagamento() {
    this.showModal = this.problemaPagamento;
  }

  modalClicked(event: MouseEvent) {
    this.fecharPopup();
  }

  dialogClicked(event: MouseEvent) {
    event.stopImmediatePropagation();
  }

  formSubmit(event: Event) {
    event.preventDefault();

    if (!this.dadosPessoais.valid && !this.pagamento.valid) {
      return;
    }

    const taskname = "login-succeded";
    try {
      this.statusService.mostrarMensagemProgresso(
        "Realizando seu cadastro...",
        taskname
      );

      let payload = <CadastroUsuarioPlanoRequest>(
        Object.assign(
          new CadastroUsuarioPlanoRequest(),
          this.dadosPessoais.value
        )
      );

      payload = <CadastroUsuarioPlanoRequest>(
        Object.assign(payload, this.pagamento.value)
      );

      if (this.problemaPagamento) {
        this.assinaturaService.alterarPlano(payload);
        this.auth.atualizaProblemaPagamento(this.auth.getAccessToken());
        this.problemaPagamento = false;
      } else {
        this.assinaturaService.assinarPlano(payload);
        this.assinaturaService.atualizaPlanoAtual();
      }

      this.formNext();
    } catch (error) {
      this.errorHandlerService.handleError(error);
      this.matSnackBar.open(error.error, null, { duration: 5000 });
    } finally {
      this.statusService.ocultarMensagemProgresso(taskname);
    }
  }

  buscarCep() {
    const group = <FormGroup>this.dadosPessoais;

    let cep = <string>group.controls["cep"].value;
    cep = cep.replace(".", "").replace("-", "");

    if (cep !== "") {
      this.consultaCepService.getConsultaCep(cep).subscribe({
        next: (result) => {
          const resultado = <EnderecoModel>result;
          if (resultado) {
            group.patchValue({
              logradouro: resultado.logradouro,
              bairro: resultado.bairro,
              cidade: resultado.localidade,
              uf: resultado.uf,
            });
          }
        },
        error: (error) => {
          this.errorHandlerService.handleError(error);
        },
      });
    }
  }

  formNext() {
    this.formStep += 1;
  }

  formPrevious() {
    this.formStep -= 1;
  }

  fecharPopup() {
    if (!this.plano?.trialGratuito || this.diasRestantesAvaliacao > 0) {
      this.showModal = false;
    }
    window.location.reload();
  }
  fecharProblemaPopup() {
    this.showModal = false;
    window.location.reload();
  }
}
